import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Button from '../ui/Button';
import PageHeader from '../ui/PageHeader';
import TalentAvailabilityView from '../components/TalentAvailabilityView';

// /talent/availability (HD-9): the performer marks the days they can shoot. A Portal page (DESIGN rev 2.1 §3.3, light by
// default from the Portal shell). The month is the shared TalentAvailabilityView in its portal mode; the calls are its own
// (GET / POST / PATCH / DELETE /api/talent-availability, no talentId: the API uses the signed-in performer).
export default function TalentAvailability() {
  const navigate = useNavigate();
  return (
    <main className="ui ui-page ui-page--portal">
      <PageHeader title="When you can shoot" meta="Mark the days you are free to shoot. The team sees them when they plan a shoot."
        actions={<Button variant="quiet" portal icon={ArrowLeft} onClick={() => navigate('/talent')}>Your next shoots</Button>} />
      <TalentAvailabilityView portal />
    </main>
  );
}
